import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTablePaginationComponent, MdbTableDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { environment } from '../../environments/environment';
import { FacturaService } from '../factura.service';
import { VCompras } from '../vcompras';
import { VVentas } from '../VVentas';

@Component({
  selector: 'app-reimprimir',
  templateUrl: './reimprimir.component.html',
  styleUrls: ['./reimprimir.component.css']
})

export class ReimprimirComponent implements OnInit {
  fecha: string;
  lista: VVentas[]=[];
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective

  constructor( private datePipe: DatePipe,private alertService: AlertService,private api: FacturaService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }

  ngOnInit(): void {
  }


  agregar()
  {
    this.ruter.navigate(['detallecompras']);
    
  }


  print(idFac){

    let url=environment.apiReportes+"factura.rptdesign&__format=pdf&id="+idFac;
    const WindowPrt =   window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
   

  }
  anularegreso()
  {
    if(confirm("Está seguro de anular la compra")) {
      if(confirm("Se genera un nuevo egreso por devoluciòn.....")) {
      console.log("Implement delete functionality here");
    }
  }

  }

  ver(entidad: VCompras){
    this.ruter.navigate(['vercompras' ,{ id: entidad.id }]);
  }


  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) : 
    value;
  }

   cancelar(entidad:VVentas){
    if(confirm("Está seguro de anular la venta")) {
      if(confirm("Se realizar la anulacion del Egreso a Bodega")) {
        this.api.anularVenta(entidad.id.toString())
      .subscribe((
) => {

  this.alertService.info('Venta anulada')
  this.buscar();

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  

   
    }
  }

   }
  
  buscar() {

    this.api.getVentas(this.datePipe.transform(this.fecha, "dd-MM-yyyy"),
    localStorage.getItem("id"))
      .subscribe((
        data: VVentas[]) => {

        this.lista = data;

        this.lista.forEach(element => {
          if (element.tipoDoc==='F' ){
            element.tipoDoc='FACTURA';
          }
          if (element.tipoDoc==='R' ){
            element.tipoDoc='RECIBO';
            
          }
          element.numeroFactura=this.PadLeft(element.numeroFactura,9);
        });

        console.log(this.lista);
        this.mdbTable.setDataSource(this.lista);
        this.mdbTable.dataSourceChange();

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }


}
